var _path, _path2, _ellipse, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 71,
    viewBox: "0 0 56 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0975 68.1244L49.3586 41L9.29492 44L28.0975 68.1244Z",
    fill: "#05ABCF",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1316 26.8031C54.1316 40.7398 42.514 52.1061 28.0975 52.1061C13.681 52.1061 2.06348 40.7398 2.06348 26.8031C2.06348 12.8664 13.681 1.5 28.0975 1.5C42.514 1.5 54.1316 12.8664 54.1316 26.8031Z",
    fill: "#05ABCF",
    stroke: "white",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.0937,
    cy: 26.8033,
    rx: 11.9316,
    ry: 11.6148,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78125 41.5L19.054 54H22.1358L29.9331 55.0582L38.0585 53L46.7903 42L8.78125 41.5Z",
    fill: "#05ABCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVb);
export default __webpack_public_path__ + "static/media/vb.92c3def9f0ce9ac1b6c5b2caf9ffbeb5.svg";
export { ForwardRef as ReactComponent };